export function currencyFormat(val: number): string {
  if (!val) {
    val = 0;
  }
  return '$ ' + val.toFixed(2);
}

export function currencyFormatNoSpace(val: number): string {
  if (!val) {
    val = 0;
  }
  return '$' + val.toFixed(2);
}

export function currencyFormatBig(val: number): string {
  if (!val) {
    val = 0;
  }
  return '$ ' + val.toFixed(0);
}
